module.exports = __webpack_public_path__ + "img/VG.b4a1c808.png";